import { DEFAULT_QUALITY } from '../common/constants';
import { SubscriptionLossMessage, isHighLevelUpdate, isKeyValueKeyListUpdate, isKeyValueUpdate, isNotationFieldSubsampleSubscriptionUpdate, isSubscriptionLossMessage } from '../message';
import { EndpointHandler } from './subscription/EndpointHandler';
import { SubjectManager } from './subscription/SubjectManager';
var SubscriptionModule = (function () {
    function SubscriptionModule(client, requestModule) {
        this.client = client;
        this.logger = this.client.getLogger();
        this.subjectManager = new SubjectManager(this.logger);
        this.handler = {
            endpoint: new EndpointHandler(client, this.subjectManager)
        };
        requestModule.setUpdateMessageHandler(this.updateHandler.bind(this));
        requestModule.setLossMessageHandler(this.lossHandler.bind(this));
    }
    SubscriptionModule.prototype.setLogger = function (logger) {
        this.logger = logger;
    };
    SubscriptionModule.prototype.observeEndpoint = function (method, path, data, options) {
        return this.handler.endpoint.observe(method, path, data, options);
    };
    SubscriptionModule.prototype.unobserveEndpoint = function (idJob) {
        return this.handler.endpoint.unobserve(idJob);
    };
    SubscriptionModule.prototype.restartSubscriptions = function () {
        this.handler.endpoint.restartSubscriptions();
    };
    SubscriptionModule.prototype.clearPendingSubscriptions = function () {
        this.subjectManager.jobs.forEach(function (subject, jobId) {
            var lossMsg = new SubscriptionLossMessage({
                Message: 'Foundation::SubscriptionLossMessage',
                Version: 2,
                header: {
                    id_job: parseInt(jobId),
                    id_service: 0
                },
                reason: {
                    value: 1
                }
            });
            subject.error(lossMsg);
        });
        this.subjectManager.jobs.clear();
    };
    SubscriptionModule.prototype.clearPendingSubscription = function (id_job) {
        this.subjectManager.jobs.forEach(function (subject, jobId) {
            if (id_job === Number(jobId)) {
                var lossMsg = new SubscriptionLossMessage({
                    Message: 'Foundation::SubscriptionLossMessage',
                    Version: 2,
                    header: {
                        id_job: parseInt(jobId),
                        id_service: 0
                    },
                    reason: {
                        value: 1
                    }
                });
                subject.error(lossMsg);
            }
        });
        this.subjectManager.jobs.delete(id_job.toString());
    };
    SubscriptionModule.prototype.lossHandler = function (msg) {
        try {
            var subject = this.findSubject(msg);
            this.logger.debug("Received Loss Message " + msg.name, msg);
            subject.error("Subscription lost: " + msg);
        }
        catch (err) {
            this.logger.warn('Received Loss Message but could not find corresponding subject', msg);
        }
    };
    SubscriptionModule.prototype.updateHandler = function (msg) {
        try {
            var subject = this.findSubject(msg);
            this.logger.debug("Received Update Message " + msg.name, msg);
            subject.next(msg);
        }
        catch (err) {
            this.logger.warn('Received Update Message but could not find corresponding subject', msg);
        }
    };
    SubscriptionModule.prototype.findSubject = function (msg) {
        if (isHighLevelUpdate(msg)) {
            return this.subjectManager.findJobSubject(msg.jobId);
        }
        if (isNotationFieldSubsampleSubscriptionUpdate(msg)) {
            return this.subjectManager.findJobSubject(msg.jobId);
        }
        if (isKeyValueUpdate(msg)) {
            return this.subjectManager.findJobSubject(msg.jobId);
        }
        if (isKeyValueKeyListUpdate(msg)) {
            return this.subjectManager.findJobSubject(msg.jobId);
        }
        if (isSubscriptionLossMessage(msg)) {
            return this.subjectManager.findJobSubject(msg.jobId);
        }
        throw new Error("Received unknown message: " + msg.name);
    };
    SubscriptionModule.defaultObserveOptions = {
        quality: DEFAULT_QUALITY
    };
    return SubscriptionModule;
}());
export { SubscriptionModule };
//# sourceMappingURL=SubscriptionModule.js.map